<template>
  <HomeRubricProducts
    block="discussed"
    :products="products"
    :loading="fetchingRubric"
  >
    <template #title>
      {{ $t('common.most_reviewed_products_title') }}
    </template>
  </HomeRubricProducts>
</template>

<script setup lang="ts">
import type { ServerListResponse } from '~/types/api/response.types'
import type { ProductCatalog } from '~/types/product'

const products = computed(() => data.value?.results || [])
const fetchingRubric = computed(() => {
  return ['idle', 'pending'].includes(status.value)
})

const { status, data } = useLazyAPI<ServerListResponse<ProductCatalog>>(
  `/api/catalog/products/?limit=16&ordering=most_reviewed`,
  {
    server: false
  }
)
</script>

<style scoped lang="scss">
.disscused {
  &__new-reviews {
    margin-top: 6px;
    font-size: 1.2rem;
    line-height: 1.8rem;

    &--count {
      color: #009939;
    }
  }
}
</style>
